import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface FormState {
  values: Record<string, unknown>;
  isDirty: boolean;
}

export interface FormPersistenceState {
  forms: Record<string, FormState>;
}

const initialState: FormPersistenceState = {
  forms: {},
};

const formPersistenceSlice = createSlice({
  name: 'formPersistence',
  initialState,
  reducers: {
    setFormValues: (
      state,
      action: PayloadAction<{
        formId: string;
        values: Record<string, unknown>;
      }>,
    ) => {
      const { formId, values } = action.payload;
      state.forms[formId] = {
        values,
        isDirty: true,
      };
    },
    setFormDirty: (
      state,
      action: PayloadAction<{ formId: string; isDirty: boolean }>,
    ) => {
      const { formId, isDirty } = action.payload;
      if (state.forms[formId]) {
        state.forms[formId].isDirty = isDirty;
      }
    },
    clearForm: (state, action: PayloadAction<string>) => {
      delete state.forms[action.payload];
    },
  },
});

export const { setFormValues, setFormDirty, clearForm } =
  formPersistenceSlice.actions;

export const formPersistenceReducer = formPersistenceSlice.reducer;
